module.exports = __webpack_public_path__ + "static/sui-button-group-labeled-icon-0fcbe1bbd229778699814eeef70af921.png";